import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import _ from 'lodash';
import Checkbox from './checkbox';
import { CheckboxInput } from './checkbox';
import $ from 'jquery';
import { strings } from 'config';
import { numberTranslate } from 'utils';

class CheckboxGroup extends Component {
  constructor() {
    super();
    this.state = {
      filtersOpen: false
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.slideToggleContent();
  }

  slideToggleContent() {
    let self = this;
    $(ReactDOM.findDOMNode(this.refs.checkboxGroup))
      .find('.expand-icon')
      .click(function() {
        $(ReactDOM.findDOMNode(self.refs.checkboxGroup)).toggleClass('expanded');
      });
  }

  onChange() {
    this.props.onGroupChange(this.props.title);

    let parentInputChecked = $(ReactDOM.findDOMNode(this.refs.checkboxGroup)).find(
      '.parent-input:checked'
    ).length;
    if (parentInputChecked) {
      $(ReactDOM.findDOMNode(this.refs.checkboxGroup)).addClass('expanded');
    }
  }

  getCount = title => {
    const { dataList } = this.props;

    if (dataList) {
      return _.filter(dataList, {
        categories: [
          {
            title: title
          }
        ]
      });
    }
  };

  render() {
    const { checked, title, titleNp, children, onItemChange, dataList } = this.props;
    const selectedLang = strings.getLanguage();

    const categoryCount = this.getCount(title);

    return (
      <CheckboxSection ref="checkboxGroup">
        <div className="header" onClick={this.slideToggle}>
          <CheckboxInput>
            <input
              type="checkbox"
              checked={checked}
              onChange={this.onChange}
              className="parent-input"
            />
            <span className="checkbox" />
            {selectedLang === 'en' ? title : titleNp} ({numberTranslate(categoryCount.length)})
          </CheckboxInput>

          <ExpandIcon className="expand-icon">
            <span />
            <span />
          </ExpandIcon>
        </div>

        <div className="sub-filters">
          {_.map(children, function(childItem) {
            return (
              <Checkbox
                dataList={dataList}
                filter="subCategory"
                key={childItem.title}
                onChange={onItemChange.bind(null, title)}
                {...childItem}
              />
            );
          })}
        </div>
      </CheckboxSection>
    );
  }
}

export default CheckboxGroup;

const CheckboxSection = styled.div`

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 10px 18px 10px 18px;
    > div {
      margin-left: 10px;
    }
  }

  &:first-child{
    .header{
        padding-top: 0;
    }
  }

  .sub-filters {
    padding: 0 18px 20px 40px;
    display: none;

    > label {
      &:not(:last-child) {
        margin-bottom: 12px;
      }
    }
  }

  &.expanded {
    .header {
      font-weight: 600;
    }
    .sub-filters {
      display: block;
    }
    .expand-icon
      > span:last-child {
        opacity: 0;
      }
    }
  }

  
`;

const ExpandIcon = styled.div`
  display: inline-block;
  cursor: pointer;
  width: 8px;
  height: 8px;
  padding: 6px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #147cd7;

  > span {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #147cd7;
    transition: all 0.1s ease-in;

    &:first-child {
      width: 8px;
      height: 1px;
    }
    &:last-child {
      width: 1px;
      height: 8px;
    }
  }

  &:hover {
    background-color: #147cd7;
    > span {
      background-color: #fff;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/checkboxTree/checkboxGroup.js